import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const areaService = {
  getAreasByIdUsuario,
  guardarArea,
  getAreasByIdEmpresa,
  eliminarAreaUsuarioById,
  asignarAreaUsuario,
  getAreaSinAsignarByIdUsuario,
  getAreaByIdProyecto,
}

async function getAreasByIdUsuario(id, idEmpresa) {
  return await ApiBudgety.get('Area/FindByIdUsuario/' + id + '/' + idEmpresa)
}

async function guardarArea(area) {
  return await ApiBudgety.post('Area/InsertOrUpdate/', area, {
    headers: {
      ACCION: MenusSistema.mantenedor_area.accesos.crear_editar_area,
      MENU: MenusSistema.mantenedor_area.id,
    },
  })
}

async function getAreasByIdEmpresa(id) {
  return await ApiBudgety.get('Area/FindByIdEmpresa/' + id)
}

async function getAreaByIdProyecto(id) {
  return await ApiBudgety.get('Area/FindByIdProyecto/' + id)
}

async function eliminarAreaUsuarioById(body) {
  return await ApiBudgety.post('Area/EliminarAreaUsuarioById', body, {
    headers: {
      ACCION: MenusSistema.permisos_usuario.accesos.editar_areas_asignadas,
      MENU: MenusSistema.permisos_usuario.id,
    },
  })
}

async function asignarAreaUsuario(body) {
  return await ApiBudgety.post('Area/AsignarUsuario', body, {
    headers: {
      ACCION: MenusSistema.permisos_usuario.accesos.editar_areas_asignadas,
      MENU: MenusSistema.permisos_usuario.id,
    },
  })
}

async function getAreaSinAsignarByIdUsuario(id, idEmpresa) {
  return await ApiBudgety.get('Area/FindSinAsignarByIdUsuario/' + id + '/' + idEmpresa)
}
